import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Question, QuestionsGroup } from '../questions';
import { Messages, errorMessagesActions, errorMessagesSelectors } from '../messages';
import { reduxFormSelectors } from '~/utils';
import { Title } from '~/elements';

import stylesCommon from './Section.scss';

export class Section extends PureComponent {
  state = {
    isSectionInvalid: false,
    questionsNames: [],
  };

  static getDerivedStateFromProps(
    {
      questionSectionErrorNames,
      errorMessage,
      formSectionName,
      touchedQuestionSectionErrors,
      hasAppErrorMessage,
      dispatchPushSectionError,
      dispatchClearSectionErrors,
      dispatchRemoveSingleErrorMessage,
    },
    { isSectionInvalid: prevIsSectionInvalid, questionsNames },
  ) {
    const isSectionInvalid = questionSectionErrorNames.some(
      (key) => questionsNames.findIndex((name) => name === key) !== -1,
    );

    if (isSectionInvalid && !prevIsSectionInvalid) {
      dispatchPushSectionError(`${errorMessage}:${formSectionName}`);
    }

    if (touchedQuestionSectionErrors.length === 0 && hasAppErrorMessage) {
      dispatchRemoveSingleErrorMessage(errorMessage);
    }

    if (!isSectionInvalid && hasAppErrorMessage) {
      if (errorMessage.indexOf(':') > -1) {
        const section = errorMessage.split(':')[0];
        dispatchClearSectionErrors(`${section}:${formSectionName}`);
      } else {
        dispatchClearSectionErrors(formSectionName);
      }
      dispatchRemoveSingleErrorMessage(errorMessage);
    }
    return { isSectionInvalid };
  }

  componentDidMount() {
    const { questions } = this.props;
    const parentQuestionsNames = questions.map((el) => el.reduxFieldConfig.name);
    this.setState((prevState) => ({
      questionsNames: [...new Set(parentQuestionsNames.concat(prevState.questionsNames))],
    }));
  }

  addQuestionsNames = (names) => {
    this.setState((prevState) => ({
      questionsNames: prevState.questionsNames.concat(names),
    }));
  };

  removeQuestionsNames = (names) => {
    this.setState((prevState) => ({
      questionsNames: prevState.questionsNames.filter((name) => !names.includes(name)),
    }));
  };

  render() {
    const {
      title,
      description,
      questions,
      formSectionName,
      dataTest,
      errorMessage,
      editMode,
      extraClassName,
    } = this.props;

    if (questions?.length === 0) {
      return null;
    }

    return (
      <fieldset className={`${stylesCommon.Section} ${extraClassName}`} data-testid={dataTest}>
        {title && <Title className={stylesCommon.SectionTitle}>{title}</Title>}
        <Messages forTypes={[errorMessage]} />
        {description && <p>{description}</p>}
        {questions &&
          questions.map((question) =>
            question.children && question.children.length ? (
              <QuestionsGroup
                question={question}
                formSectionName={formSectionName}
                addQuestionsNames={this.addQuestionsNames}
                removeQuestionsNames={this.removeQuestionsNames}
                editMode={editMode}
                sectionTitle={title}
                key={question.id}
              />
            ) : (
              <Question
                question={question}
                editMode={editMode}
                sectionTitle={title}
                formSectionName={formSectionName}
                key={question.id}
              />
            ),
          )}
      </fieldset>
    );
  }
}

export const mapStateToProps = (state, { errorMessage }) => ({
  questionSectionErrorNames: reduxFormSelectors.selectQuestionSectionErrorNames(state),
  touchedQuestionSectionErrors: reduxFormSelectors.selectTouchedQuestionSectionErrors(state),
  hasAppErrorMessage: !!errorMessagesSelectors.selectAppErrorMessage(errorMessage)(state),
});

const mapDispatchToProps = {
  dispatchRemoveSingleErrorMessage: errorMessagesActions.removeSingleErrorMessage,
  dispatchPushSectionError: errorMessagesActions.pushSectionError,
  dispatchClearSectionErrors: errorMessagesActions.clearSectionErrors,
};

export const ConnectedSection = connect(mapStateToProps, mapDispatchToProps)(Section);

Section.propTypes = {
  title: PropTypes.string,
  editMode: PropTypes.bool,
  description: PropTypes.string,
  questions: PropTypes.arrayOf(PropTypes.shape({})),
  formSectionName: PropTypes.string.isRequired,
  dataTest: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
  extraClassName: PropTypes.string,
  hasAppErrorMessage: PropTypes.bool.isRequired,
  questionSectionErrorNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  touchedQuestionSectionErrors: PropTypes.arrayOf(PropTypes.any).isRequired,
  dispatchPushSectionError: PropTypes.func.isRequired,
  dispatchClearSectionErrors: PropTypes.func.isRequired,
  dispatchRemoveSingleErrorMessage: PropTypes.func.isRequired,
};

Section.defaultProps = {
  title: undefined,
  description: '',
  questions: [],
  editMode: false,
  extraClassName: null,
};
